(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return;

      this.header.classList.add('shopify-section-header-sticky');
      this.scrolled = false;
      this.ticking = false;

      this.setHeaderHeight();

      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = () => { this.setHeaderHeight(); this.update(); };
      this.onClickHandler = (event) => {
        if (event.target.closest && event.target.closest('.pt-top')) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      };

      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onResizeHandler);
      document.addEventListener('click', this.onClickHandler);

      this.update();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
      document.removeEventListener('click', this.onClickHandler);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
    }

    update() {
      const y = window.pageYOffset || document.documentElement.scrollTop || 0;

      // Pill header: small hysteresis so it never flickers at the threshold
      const next = this.scrolled ? y > 10 : y > 50;
      if (next !== this.scrolled) {
        this.scrolled = next;
        this.header.classList.toggle('scrolled-past-header', next);
        this.closeMenuDisclosure();
      }

      // Blue progress line
      this.progressBar = this.progressBar || document.querySelector('.pt-progress__bar');
      if (this.progressBar) {
        const max = document.documentElement.scrollHeight - window.innerHeight;
        const progress = max > 0 ? Math.min(1, Math.max(0, y / max)) : 0;
        this.progressBar.style.transform = 'scaleX(' + progress + ')';
      }

      // Back to top button
      this.topButton = this.topButton || document.querySelector('.pt-top');
      if (this.topButton) {
        this.topButton.classList.toggle('is-visible', y > 600);
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => { if (disclosure.close) disclosure.close(); });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
